import { Paper } from "material-ui";
import React from "react";
import { FormattedMessage } from "react-intl";
import ProblemReportsTable from "./ProblemReportsTable";

class ProblemReports extends React.Component {
  componentDidMount() {
    this.props.getReports();
  }
  render() {
    return (
      <Paper
        style={{
          borderRight: "2px solid #e3e3e3",
          padding: "10px",
          margin: "10px",
        }}
      >
        <h4>
          <FormattedMessage id="DomainFVliteNavigation.problemReport" />
        </h4>
        <ProblemReportsTable {...this.props} />
      </Paper>
    );
  }
}

export default ProblemReports;



// WEBPACK FOOTER //
// src/routes/ProblemReports/ProblemReports.js